export function getType(value){return null===value?"null":Array.isArray(value)?"array":typeof value}